export const markersSchema = { id: 1, createdAt: 2, updatedAt: 3, latitude: 4, longitude: 5, G: 6, Y: 7, R: 8, Gc: 9, Yc: 10, Rc: 11, active: 12 };
